import { defineMessages } from 'react-intl';

export default defineMessages({
  selectOne: {
    description: 'Placeholder text shown in the advanced search dropdown when no option is selected',
    defaultMessage: 'Select One...',
    id: '7L+G/g',
  },
});
